import { useEffect } from 'react';

const useSearchShortcut = (onOpen) => {
    useEffect(() => {
        const handleKeyDown = (e) => {

            if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
                e.preventDefault();
                onOpen();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onOpen]);
};

export { useSearchShortcut };